// extracted by mini-css-extract-plugin
module.exports = {"root":"DealerDetails_root__zGLOD","_information":"DealerDetails__information__7xXVL","_text":"DealerDetails__text__Dl5IQ"};